import { render, staticRenderFns } from "./channel-list.vue?vue&type=template&id=3f0ab9e6&scoped=true&lang=pug"
import script from "./channel-list.vue?vue&type=script&lang=js"
export * from "./channel-list.vue?vue&type=script&lang=js"
import style0 from "./channel-list.vue?vue&type=style&index=0&id=3f0ab9e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0ab9e6",
  null
  
)

export default component.exports